<template>
    <section class="container">
        <resumen-componente/>
        <div class="container-fluid">
            <mapa v-model="formulario.agencia" :provincia="pasosAn[1].provincia"></mapa>
        </div>
        <div class="pt-5 d-flex justify-content-between align-text-bottom abajo">
            <button type="button" class="btn btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
            <button type="button" class="btn btn-primary btn-font-sm" v-on:click="siguiente" :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''" :disabled="cargando"> {{ logeado ? 'Agregar cotización venta en linea' : 'Cotizar' }} <i class="flaticon2-next"></i></button>
        </div>
    </section>

</template>

<script>
    import mapa from "../../componentes/kia-mapa";
    import ResumenComponente from "./resumen-componente";
    import {oportunidad} from "../../servicios";
    export default {
        name: "resumen",
        data:()=>({
            formulario:{
                agencia:{id:null}
            },
            cargando:false,
        }),
        components:{
            mapa,
            ResumenComponente
        },
        computed:{
            pasosAn:function(){
                return this.$store.getters.getPasos;
            },
          logeado:function(){
              return this.$store.getters.getUsuario.ndt1;
          }
        },
        watch:{
            "formulario.agencia":{
                handler(valor){
                    let formulario=this.$store.getters.getPasos[3];
                    formulario.agencia=valor;
                    this.$store.commit('setPaso',{p:"3",data:formulario});
                },
                deep: true
            },
        },
        methods:{
            atras:function(){
                this.$store.commit('setActual',2);
                this.$store.commit('setSubActual',4);
                this.$router.push({ name: 'p2', params: { titulo:  this.$route.params.titulo ,id:this.$route.params.id} });
            },
            siguiente:function(){
                if(this.formulario.agencia.id){
                    this.$store.commit('setActual',4);
                    if(this.$store.getters.getUsuario.ndt1){
                        this.cargando=true;
                        oportunidad.nuevaCotizacion(this.$store.getters.getPasos).then(()=>{
                            this.$toast.success("Se ha Agregado Correctamente");
                            this.cargando=false;
                            this.$router.push({ name: 'cotizaciones'});
                        }).catch(()=>{
                          this.cargando=false;
                        });
                    }else{
                        this.$router.push({ name: 'p4', params: { titulo:  this.$route.params.titulo ,id:this.$route.params.id} });
                    }
                }else{
                    this.$toast.show(`Selecciona una Agencia para ser atendido`);
                }
            },
        },
      mounted() {
          if(!this.$store.getters['getPasos'][1].modelo.id){
            this.atras()
          }
      }
    }
</script>

<style scoped>

</style>
